import React, { useEffect, useState } from "react";
import { Tooltip } from "@mui/material";
import { useMap } from "../contexts/MapContext";

const CompassButton: React.FC = () => {
  const { map } = useMap();
  const [bearing, setBearing] = useState(0);

  useEffect(() => {
    if (!map) return;
    setBearing(map.getBearing());
    const onRotate = () => setBearing(map.getBearing());
    map.on("rotate", onRotate);
    return () => { map.off("rotate", onRotate); };
  }, [map]);

  const handleClick = () => {
    if (!map) return;
    map.easeTo({ bearing: 0, duration: 300 });
  };

  return (
    <Tooltip title="Reset to north" placement="right">
      <button
        onClick={handleClick}
        style={{
          position: "absolute",
          top: 10,
          left: 10,
          width: 46,
          height: 46,
          borderRadius: "50%",
          background: "rgba(33, 43, 55, 0.88)",
          border: "1px solid rgba(148, 163, 184, 0.25)",
          cursor: "pointer",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          zIndex: 1000,
          boxShadow: "0 2px 6px rgba(0,0,0,0.35)",
          padding: 0,
        }}
      >
        <svg
          width="34"
          height="34"
          viewBox="0 0 28 28"
          style={{
            transform: `rotate(${-bearing}deg)`,
            transition: "transform 0.1s linear",
          }}
        >
          {/* North half — red */}
          <polygon points="14,2 17,14 11,14" fill="#ef4444" />
          {/* South half — light */}
          <polygon points="14,26 17,14 11,14" fill="rgba(255,255,255,0.7)" />
          {/* Center cap */}
          <circle cx="14" cy="14" r="2.2" fill="#94a3b8" />
        </svg>
      </button>
    </Tooltip>
  );
};

export default CompassButton;
